import { Component, Input, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Guid } from '@app/core/constants/constants';

import { ImageUploaderComponent } from './components/image-uploader/image-uploader.component';

@Component({
    selector: 'app-image-editor',
    templateUrl: './image-editor.component.html',
    styleUrls: ['./image-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageEditorComponent implements OnInit {

  @Input()
  public editMode: boolean = false;

  public _title: string = "Not Found";

  @Input()
  public get title(): string {
    return this._title;
  }
  public set title(value: string) {
    this._title = value;

    if (!value) return;
    
    this.setFirstLetters();
  }

  firstLetters: string = "NF";



  @Input()
  public id: Guid;

  @Input()
  public imageUrl: string;


  @Output()
  public imageChanged: EventEmitter<{imageUrl: string, imageId?: string}> = new EventEmitter<{imageUrl: string, imageId?: string}>();


  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  setFirstLetters() {
    let words = this.title?.split(" ");
    let firstLetters = "";
    for (let i = 0; i < Math.min(words.length, 3); i++) {
      firstLetters += words[i].charAt(0);
    }
    this.firstLetters = firstLetters;
  }

  openDialog() {
    const dialogRef = this.dialog.open(ImageUploaderComponent, {
      disableClose: true,
      width: 'fit-content',
      maxWidth: 'calc(100vw - 48px)',
      height: 'auto',
      maxHeight: 'calc(100vh - 48px)',
      panelClass: 'image-uploader-dialog-panel',
      data: this.id
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      if (!result.imageUrl) return;

      this.imageUrl = result.imageUrl;
      this.imageChanged?.emit({ imageUrl: this.imageUrl, imageId: result.imageId });
    });
  }

  deleteImage() {
    this.imageUrl = null;
    this.imageChanged?.emit({ imageUrl: this.imageUrl, imageId: null });
  }
}
